/* ============================================================
   CLAIREVIEW PEPTIDES — cp-ratings.js
   Deterministic per-product ratings + SVG star renderer.

   A product's rating is derived ONLY from its handle, so it is
   identical everywhere it appears (cards, collection, product
   info, reviews summary) and never changes between page loads.

     rating ∈ {4, 4.5, 5}
     review count ∈ [100, 312]
   ============================================================ */
(function () {
  'use strict';

  var STAR_PATH = 'M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4 7.3 13.6 2.2 9l6.9-.7z';
  var gradSeq = 0;

  /* FNV-1a 32-bit hash — stable across loads and browsers */
  function hashStr(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  /* Deterministic rating + review count from a product handle */
  function ratingFor(handle) {
    var h = hashStr(handle || 'cp');
    var tiers = [4, 4.5, 5];
    return {
      rating: tiers[h % 3],
      count: 100 + (Math.floor(h / 3) % 213) // 100..312
    };
  }

  /* Build 5-star SVG markup for a rating (rounded to nearest half) */
  function starsHTML(rating) {
    var html = '<span class="cp-stars" role="img" aria-label="' + rating + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) {
      var type;
      if (rating >= i) {
        type = 'full';
      } else if (rating >= i - 0.5) {
        type = 'half';
      } else {
        type = 'empty';
      }
      html += star(type);
    }
    html += '</span>';
    return html;
  }

  function star(type) {
    /* Empty stars ALWAYS carry the base "cp-star" class (sizing) */
    if (type === 'half') {
      var id = 'cpHalf' + (gradSeq++);
      return '<svg class="cp-star cp-star--half" viewBox="0 0 24 24" aria-hidden="true">' +
        '<defs><linearGradient id="' + id + '">' +
        '<stop offset="50%" stop-color="var(--cp-star-on)"/>' +
        '<stop offset="50%" stop-color="var(--cp-star-off)"/>' +
        '</linearGradient></defs>' +
        '<path fill="url(#' + id + ')" d="' + STAR_PATH + '"/></svg>';
    }
    return '<svg class="cp-star cp-star--' + type + '" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="' + STAR_PATH + '"/></svg>';
  }

  /* Render a [data-cp-rating] element (handle-driven) */
  function renderRating(el) {
    if (el.dataset.cpDone === '1') return;
    var data = ratingFor(el.dataset.handle);
    var mode = el.dataset.mode || 'compact';
    var html = starsHTML(data.rating);
    if (mode !== 'stars') {
      var label = data.rating + ' · ' + data.count.toLocaleString();
      if (mode === 'full') label = data.rating + ' · ' + data.count.toLocaleString() + ' reviews';
      html += '<span class="cp-rating__count cp-mono">' + label + '</span>';
    }
    el.innerHTML = html;
    el.dataset.cpDone = '1';
  }

  /* Render a [data-cp-stars] element (fixed rating, e.g. hero) */
  function renderStars(el) {
    if (el.dataset.cpDone === '1') return;
    var rating = parseFloat(el.dataset.rating) || 5;
    var display = Math.round(rating * 2) / 2;
    var html = starsHTML(display);
    if (el.dataset.count) {
      html += '<span class="cp-rating__count cp-mono">' + rating + ' · ' + el.dataset.count + '</span>';
    }
    el.innerHTML = html;
    el.dataset.cpDone = '1';
  }

  function scan(root) {
    root = root || document;
    root.querySelectorAll('[data-cp-rating]').forEach(renderRating);
    root.querySelectorAll('[data-cp-stars]').forEach(renderStars);
  }

  /* Public API — used by product page reviews section too */
  window.CP = window.CP || {};
  window.CP.ratingFor = ratingFor;
  window.CP.starsHTML = starsHTML;
  window.CP.scanRatings = scan;
  window.CP.hash = hashStr;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
